import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import loadable from '@loadable/component';

export default function Router({ cmsUrls }) {
  return (
    <Switch>
      {cmsUrls.map(cmsUrl => (
        <Route key={cmsUrl} component={loadable(() => import('../CMSPage'))} exact path={`/${cmsUrl}`} />
      ))}
      <Route exact path="/" component={loadable(() => import('../HomePage'))} />
      <Route exact path="/about/timeline" component={loadable(() => import('../TimelinePage'))} />
      <Route exact path="/account/favorite-lists" component={loadable(() => import('../FavoriteStationsListsPage'))} />
      <Route exact path="/account/favorite-lists/:favoriteListId" component={loadable(() => import('../FavoritesListPage'))} />
      <Route exact path="/account/fuel-log-book" component={loadable(() => import('../RedirectToFuelLogBook'))} />
      <Route exact path="/account/preferences" component={loadable(() => import('../UserEmailPreferencesPage'))} />
      <Route exact path="/account/profile" component={loadable(() => import('../ProfilePage'))} />
      <Route exact path="/account/savings" component={loadable(() => import('../PaySavingsPage'))} />
      <Route exact path="/account/vehicles" component={loadable(() => import('../MyVehiclesPage'))} />
      <Route exact path="/account/vehicles/:guid" component={loadable(() => import('../MyVehicleProfilePage'))} />
      <Route exact path="/account/vehicles/:guid/fuel-log-book" component={loadable(() => import('../FuelLogBookPage'))} />
      <Route exact path="/account/vehicles/:guid/fuel-log-book/entry/:fuelLogGuid?" component={loadable(() => import('../FuelLogEntryPage'))} />
      <Route exact path="/app" component={loadable(() => import('../AppPage'))} />
      <Route exact path="/brands/:brandKey" component={loadable(() => import('../BrandPage'))} />
      <Route exact path="/contest/gas-card-give-away" component={loadable(() => import('../EnterToWinPage'))} />
      <Route path="/disclaimer/:countryCode?" component={loadable(() => import('../LegalPage'))} />
      <Route exact path="/do-not-sell-my-personal-information" component={loadable(() => import('../DoNotSellMyPI'))} />
      <Route exact path="/emailpreferences" component={loadable(() => import('../VisitorPreferencesPage'))} />
      <Route exact path="/gasback" component={loadable(() => import('../GasbackLanding'))} />
      <Route exact path="/gasprices" component={loadable(() => import('../RegionSelectPage'))} />
      <Route exact path="/gasprices/:region/:area?/:countyId?" component={loadable(() => import('../RegionalGasPrices'))} />
      <Route exact path="/home" component={loadable(() => import('../SearchResultsPage'))} />
      <Route exact path="/pay/dynamic/beta" component={loadable(() => import('../DynamicDiscountBetaPage'))} />
      <Route exact path="/pay/dynamic/info" component={loadable(() => import('../DynamicDiscountPage'))} />
      <Route exact path="/pay/plus" component={loadable(() => import('../PayPlusPage'))} />
      <Route exact path="/pay/shop-your-way" component={loadable(() => import('../ShopYourWayPage'))} />
      <Route path="/privacy/:countryCode?" component={loadable(() => import('../LegalPage'))} />
      <Route exact from="/station/:brandName/:regionCode/:regionDescription/:stationId([0-9]+)" to="/station/:stationId" />
      <Route exact path="/station/:stationId([0-9]+)" component={loadable(() => import('../Station'))} />
      <Route path="/terms/:countryCode?" component={loadable(() => import('../LegalPage'))} />
      <Route exact path="/ubi/quote" component={loadable(() => import('../UbiQuote'))} />
      <Route exact path="/vehicles/recalls/results" component={loadable(() => import('../VehicleRecallSearchResultsPage'))} />
      <Route exact path="/vehicles/recalls/search" component={loadable(() => import('../VehicleRecallSearchPage'))} />
      <Route component={loadable(() => import('../Unknown'))} />
    </Switch>
  );
}

Router.propTypes = {
  cmsUrls: PropTypes.arrayOf(PropTypes.string),
};

Router.defaultProps = {
  cmsUrls: [],
};
